import React, { useState } from "react";
import "../../App.css";
import "./Navbar.css";
function Navbar() {
  const [times, setTimes] = useState(false);
  const [active, setActive] = useState(false);
  const handleBar = () => {
    times ? setTimes(false) : setTimes(true);
    active ? setActive(false) : setActive(true);
  };
  const navlinkHandler = () => {
    setTimes(false);
    setActive(false);
  };

  return (
    <>
      <header id="header">
        <nav>
          <div className="container flex justify-between items-center">
            <div className="brand">
              <i className="fas fa-heartbeat"></i> <span>medicare.</span>
            </div>
            <div id="menu" className={active ? "active" : "notActive"}>
              <ul className="flex">
                <li>
                  <a className="navlink" onClick={navlinkHandler} href="#hero">
                    Home
                  </a>
                </li>
                <li>
                  <a className="navlink" onClick={navlinkHandler} href="#about">
                    About
                  </a>
                </li>
                <li>
                  <a
                    className="navlink"
                    onClick={navlinkHandler}
                    href="#services"
                  >
                    Service
                  </a>
                </li>
                <li>
                  <a
                    className="navlink"
                    onClick={navlinkHandler}
                    href="#doctor"
                  >
                    Doctors
                  </a>
                </li>
                <li>
                  <a className="navlink" onClick={navlinkHandler} href="#book">
                    Book
                  </a>
                </li>
                <li>
                  <a
                    className="navlink"
                    onClick={navlinkHandler}
                    href="#reviews"
                  >
                    Reviews
                  </a>
                </li>
                <li>
                  <a className="navlink" onClick={navlinkHandler} href="#blog">
                    Blog
                  </a>
                </li>
              </ul>
            </div>
            <div
              id="menu-bar"
              onClick={handleBar}
              className={times ? "fas fa-times" : "fas fa-bars"}
            ></div>
          </div>
        </nav>
      </header>

      <section id="hero">
        <div className="container flex justify-center items-center wrap">
          <div className="hero-img flex-1">
            <img src="/img/heroSvg.svg" alt="" />
          </div>
          <div className="hero-text flex-1">
            <h1 className="heading pb">Stay safe, stay healthy</h1>
            <p className="para">
              {" "}
              nec sagittis aliquam malesuada bibendum arcu vitae elementum
              curabitur vitae nunc sed velit dignissim sodales ut eu sem integer
              vitae justo eget magna fermentum iaculis{" "}
            </p>
            <a href="/" className="btn">
              {" "}
              contact now
              <i className="fas fa-angle-right"></i>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default Navbar;
